import Scopes, { allScopes } from './Scopes'
import SpotifyAuth from './SpotifyAuth'
import SpotifyAuthListener from './SpotifyAuthListener'

Scopes.all = allScopes

export { Scopes, SpotifyAuth, SpotifyAuthListener }
